'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { useSelectTypeUrl } from '@marketplace-web/registration/identity-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { IntroductionSectionModel } from '../../types'
import { ITEM_UPLOAD_URL, SIGNUP_URL } from '../../../../constants/routes'

const IntroductionSection = ({ props: { text, testId } }: { props: IntroductionSectionModel }) => {
  const { title, description } = text
  const translate = useTranslate()
  const isListingCtaEnabled = useFeatureSwitch('dac7_listing_cta')
  const { track } = useTracking()
  const userId = useSession().user?.id
  const isNonNativeFlowAbTestEnabled = useAbTest('non_native_flow')?.variant === 'on'
  const selectTypeUrl = useSelectTypeUrl()

  const ctaUrl = userId
    ? ITEM_UPLOAD_URL
    : urlWithParams(isNonNativeFlowAbTestEnabled ? selectTypeUrl : SIGNUP_URL, {
        ref_url: ITEM_UPLOAD_URL,
      })

  const onCtaClick = () => {
    track(
      clickEvent({
        screen: 'no_changes_to_taxes',
        target: 'cta_redirect',
        targetDetails: `introduction_start_selling__${userId ? ITEM_UPLOAD_URL : SIGNUP_URL}`,
      }),
    )
  }

  return (
    <section className="secondhand-taxes__introduction" data-testid={testId}>
      <h1 className="secondhand-taxes__introduction-title">{translate(title)}</h1>
      <p
        className="secondhand-taxes__introduction-description"
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: translate(description) }}
      />
      {isListingCtaEnabled ? (
        <div className="secondhand-taxes__introduction-cta">
          <Button text={translate(text.buttonCta)} url={ctaUrl} onClick={onCtaClick} />
        </div>
      ) : null}
    </section>
  )
}

export default IntroductionSection
